module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "western",
    attrs: {
      "id": "calibre_pb_6"
    }
  }, [_c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western11"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western12"
  }, [_vm._v("This is for everyone who wanted to know what\nhappened to John.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12eda054","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_006.vue
// module id = 78
// module chunks = 0